import React, { useRef } from 'react';
import ddt from '@wix/da-ddt';
import { ViewerContainerSizeContext } from './ViewerContainerSizeContext';
import { useMeasuredCookie } from '../../Measured/useMeasuredCookie';
var MeasuredViewerContainerSizeContextProvider = function (_a) {
    var children = _a.children, cookieType = _a.cookieType, cookieDim = _a.cookieDim, listenOnWindow = _a.listenOnWindow, _b = _a.innerPadding, innerPadding = _b === void 0 ? 0 : _b, className = _a.className;
    var containerRef = useRef(null);
    var sentinelRef = useRef(null);
    var containerSize = useMeasuredCookie(cookieType, containerRef, {
        cookieDim: cookieDim,
        sentinelRef: sentinelRef,
        listenOnWindow: listenOnWindow,
    });
    var width = containerSize ? containerSize.width - innerPadding : undefined;
    ddt.log('measuredhook', 'MeasuredViewerContainerSizeContextProvider', {
        width: width,
        containerSize: containerSize,
        innerPadding: innerPadding,
    });
    return (React.createElement(ViewerContainerSizeContext.Provider, { value: width },
        React.createElement("div", { ref: sentinelRef, style: { maxWidth: '100%' } }),
        React.createElement("div", { className: className, ref: containerRef }, children)));
};
MeasuredViewerContainerSizeContextProvider.displayName =
    'MeasuredViewerContainerSizeContextProvider';
export default MeasuredViewerContainerSizeContextProvider;
//# sourceMappingURL=MeasuredViewerContainerSizeContextProvider.js.map